import type { Route } from '@angular/router';

import { AppResolver } from './app.resolver';

import { singleStationResolver } from '~components/single-station-view/single-station.resolver';
import { fuelDaysResolver } from '~components/station-locator/fuel-days.resolver';
import { StationLocatorComponent } from '~components/station-locator/station-locator.component';
import { DEFAULT_LANGUAGE } from '~constants/translations';
import { LangGuard } from '~utils/lang-guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: `/${DEFAULT_LANGUAGE}`,
    pathMatch: 'full',
  },
  {
    path: ':lang',
    component: StationLocatorComponent,
    canActivate: [LangGuard],
    resolve: { lang: AppResolver, fuelDays: fuelDaysResolver },
  },
  {
    path: ':lang/station',
    redirectTo: ':lang',
    pathMatch: 'full',
  },
  {
    path: 'station/:stationId',
    redirectTo: `${DEFAULT_LANGUAGE}/station/:stationId`,
  },
  {
    path: ':lang/station/:stationId',
    loadComponent: () =>
      import('~components/single-station-view/single-station-view.component').then((m) => m.SingleStationViewComponent),
    canActivate: [LangGuard],
    resolve: { lang: AppResolver, station: singleStationResolver },
  },
  {
    path: '**',
    redirectTo: `/${DEFAULT_LANGUAGE}`,
  },
];
